import { useQuery } from '@tanstack/react-query';
import { BotsActivityContentResponse } from '../../../types/bots-activity/BotsActivityContentResponse';
import { getContent } from '../../../services/bots-activity/BotsActivityService';
import { GET_BOTS_ACTIVITY_CONTENT } from '../../query/bots-activity/keys';

const EMPTY_CONTENT: BotsActivityContentResponse = { content: [] };

export const useGetBotsActivityContent = (
  projectId: number | null,
  range: string,
  groupBy: 'folder' | 'url',
  limit: number = 10,
  /**
   * Backend bot-name filter. `null`/`undefined` = no filter. An empty array
   * means the active filter matches no bots — we skip the request entirely
   * and return an empty response (the backend would interpret `bots=` as
   * "no filter" and return everything).
   */
  bots?: string[] | null
) => {
  const isEmptySelection = Array.isArray(bots) && bots.length === 0;
  const queryEnabled = !!projectId && !isEmptySelection;
  const botsKey = bots && bots.length > 0 ? bots.join(',') : null;

  const { data, isLoading, isError, refetch } = useQuery<BotsActivityContentResponse>({
    queryKey: [GET_BOTS_ACTIVITY_CONTENT, projectId, range, groupBy, limit, botsKey],
    queryFn: () => getContent(projectId!, range, groupBy, limit, bots),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
  });

  return {
    data: isEmptySelection ? EMPTY_CONTENT : data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
